import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 60,
  },
  title: {
    fontSize: 40,
    fontFamily: 'Lato',
    fontWeight: 900,
    marginLeft: 53,
    marginRight: 53,
  },
  lineBar: {
    width: 160,
    marginLeft: 53,
    marginRight: 53,
  },
  bodyContainer: {
    paddingRight: 50,
    paddingLeft: 53,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  dayHeader: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 12,
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 12,
    paddingTop: 6,
    paddingBottom: 4,
  },
  sessionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  dayWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingTop: 20,
  },
  sessionHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    width: '100%',
    paddingTop: 10,
  },
  eventTimeWrapper: {
    backgroundColor: 'rgb(39, 52, 61)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 15,
    paddingVertical: 6,
    width: 200,
  },
  eventTime: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    color: 'white',
    textTransform: 'uppercase',
  },
  sessionTitleWrapper: {
    paddingHorizontal: 15,
    paddingVertical: 6,
    backgroundColor: '#EEEEEE',
    display: 'flex',
    flexDirection: 'row',
    flex: 1, // 🧩 Let it grow to fill the rest of the row
  },
  sessionTitle: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },
  sessionTextTitle: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 'black',
    color: 'black',
    paddingTop: 5,
    paddingBottom: 5,
    textTransform: 'uppercase',
  },
  sessionDescription: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
    paddingTop: 5,
    paddingBottom: 5,
  },
  speakersWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
  },
  speakerItem: {
    display: 'flex',
    flexDirection: 'row',
  },
  speakerName: {
    fontSize: 9,
    fontFamily: 'Lato',
    color: 'black',
  },
  speakerDetail: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },

  speakersSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    paddingTop: 10,
    width: '100%',
  },

  logoColumn: {
    width: 100,
    maxWidth: 100,
    maxHeight: 120,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  companyLogo: {
    width: 80,
    maxWidth: 80,
    height: 80,
    maxHeight: 80,
    objectFit: 'contain',
  },

  speakerGrid: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },

  speakerCard: {
    display: 'flex',
    flexDirection: 'row',
    width: '48%',
    gap: 6,
    padding: 5,
  },
  speakerImage: {
    width: 50,
    maxWidth: 50,
    height: 60,
    maxHeight: 60,
    objectFit: 'cover',
  },
  speakerInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  speakerTitle: {
    fontSize: 8,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },

  formattedDateContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
  formattedDateText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 300,
  },
});
